import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { combineLatest, Subscription } from 'rxjs';
import { debounceTime, filter, skip, switchMap, take } from 'rxjs/operators';
import { Filter } from 'src/app/classes';
import { countries, ger } from 'src/app/globals';
import { DoubletSuggestion } from 'src/app/lib/shared/classes';
import { DOUBLET_PROVIDER_SERVICE } from 'src/app/lib/shared/interfaces';
import { Address } from '../../../classes';
import { LocationService } from '../../../services/location.service';
import { AddressFormComponentService } from './address-form-component-service';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.css'],
  providers: [
    { provide: DOUBLET_PROVIDER_SERVICE, useClass: AddressFormComponentService }
  ]
})
export class AddressFormComponent implements OnDestroy, OnInit {

  @Input() editMode: boolean = true;
  @Input() appearance: 'fill' | 'outline' | 'standard' = 'outline';

  countries = countries;

  countryFlagIcon: string = ger.flagIcon;
  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(DOUBLET_PROVIDER_SERVICE) public doubletService: AddressFormComponentService,
    private _controlContainer: ControlContainer,
    private _locationService: LocationService
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;

    this.doubletService.setDoubletCheckerVisible(false);

    this._subscriptions.push(...[
      this.addressCountryControl.valueChanges.subscribe((value: string) => {
        let country = countries.find(x => x.name === value);
        this.countryFlagIcon = country.flagIcon;
      }),
      combineLatest([this.formGroup.valueChanges.pipe(debounceTime(500)), this.doubletService.checkerVisible$]).pipe(filter(([address, checkerVisible]) => checkerVisible)).subscribe(([address, checkerVisible]) => {
        this.doubletService.setSearchFilter({
          filtercondition: Object.keys(address).map((attribute: string) => {
            return { 'attribute': attribute, 'value': address[attribute], 'operation': 2 };
          }),
          type: 'AND'
        } as Filter, { 'pageNumber': 1, 'pageSize': 50 })
      }),
      this.doubletService.doubletClicked$.pipe(switchMap((suggestion: DoubletSuggestion) => this._locationService.getAddressById(suggestion.identifier, true))).subscribe((address: Address) => {
        this.formGroup.patchValue(address);
        this.doubletService.setDoubletCheckerVisible(false);
      })
    ]);
  }

  get addressCountryControl(): AbstractControl {
    return this.formGroup.controls['addresscountry'];
  }
  get addressStreetControl(): AbstractControl {
    return this.formGroup.controls['addressstreet'];
  }

}
